import { buildConsolidationLinkMetadata } from "@/lib/consolidationMetadata";
import type { ConsolidationRenderContext } from "@/hooks/useLegislationViewerContent";
import type { PostTemplateRequestBody } from "@/models/document-link/DocumentLink";

/** The document a new reference points at: whatever the user currently has open. */
export type DocumentReferenceTarget = {
  /** Accession for legislation, blob id/name for workspace documents. */
  documentId?: string;
  source?: string;
  /** Required for workspace documents. */
  workspaceId?: string;
  /** Set while a consolidation is on screen, so the reference reopens it. */
  consolidation?: ConsolidationRenderContext | null;
};

/** Narrows a reference to selected text. Omitted for whole-document references. */
export type DocumentReferenceSelection = {
  htmlIds?: string[];
  uniqueMatchText?: string;
  uniqueChunkText?: string;
};

export const buildDocumentReferenceRequest = (
  target: DocumentReferenceTarget,
  isStatic: boolean,
  selection: DocumentReferenceSelection = {}
): PostTemplateRequestBody => {
  const consolidationMetadata = buildConsolidationLinkMetadata(
    target.consolidation,
    isStatic
  );

  return {
    destinationSource: target.source || "",
    // A consolidation is identified by query params, so the link stores the
    // anchor accession and carries the snapshot in extraMetadata.
    destinationDocumentId:
      target.consolidation?.lawExternalId || target.documentId || "",
    destinationHtmlIds: selection.htmlIds ?? [],
    destinationUniqueMatchText: selection.uniqueMatchText,
    destinationUniqueChunkText: selection.uniqueChunkText,
    destinationWorkspaceId: target.workspaceId || undefined,
    isDestinationStatic: isStatic,
    extraMetadata: consolidationMetadata
      ? JSON.stringify(consolidationMetadata)
      : undefined,
  };
};
